export default __webpack_public_path__ + "static/media/home-page-boost-your-marketing.049a8849.png";